import type { CSSProperties, JSX } from 'react';
import type { Palette } from '../../../_theme/palette.js';

interface ConversationalChevronsProps {
  palette: Palette;
  canGoBack: boolean;
  canGoForward: boolean;
  onUp: () => void;
  onDown: () => void;
}

export function ConversationalChevrons({
  palette,
  canGoBack,
  canGoForward,
  onUp,
  onDown,
}: ConversationalChevronsProps): JSX.Element {
  return (
    <div style={containerStyle()}>
      <ChevronButton palette={palette} direction="up" disabled={!canGoBack} onClick={onUp} />
      <ChevronButton palette={palette} direction="down" disabled={!canGoForward} onClick={onDown} />
    </div>
  );
}

interface ChevronButtonProps {
  palette: Palette;
  direction: 'up' | 'down';
  disabled: boolean;
  onClick: () => void;
}

function ChevronButton({ palette, direction, disabled, onClick }: ChevronButtonProps): JSX.Element {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={direction === 'up' ? 'Previous question' : 'Next question'}
      style={buttonStyle(palette, disabled)}
    >
      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        {direction === 'up' ? <path d="M6 15l6-6 6 6" /> : <path d="M6 9l6 6 6-6" />}
      </svg>
    </button>
  );
}

function containerStyle(): CSSProperties {
  return {
    position: 'absolute',
    right: 20,
    bottom: 20,
    display: 'flex',
    gap: 6,
  };
}

function buttonStyle(palette: Palette, disabled: boolean): CSSProperties {
  return {
    width: 34,
    height: 34,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${palette.border}`,
    borderRadius: 8,
    background: palette.card,
    color: palette.text,
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.4 : 1,
    padding: 0,
  };
}
